import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';

const adClasses = cva('flex justify-center items-center', {
  variants: {
    adType: {
      top: 'min-h-[60px] md:min-h-[270px]',
      belowTopSection: 'min-h-[60px] md:min-h-[270px]',
      belowSecondSection: 'min-h-[60px] md:min-h-[270px]',
      sidebar1: '',
      sidebar2: 'sticky top-[60px] pt-5',
      stickyBottom: 'sticky bottom-0 bg-transparent z-10',
      oneOnOne: '',
    },
  },
});

type AdType = {
  id: string;
  cssClasses?: string;
  location:
    | 'top'
    | 'belowTopSection'
    | 'belowSecondSection'
    | 'sidebar1'
    | 'sidebar2'
    | 'oneOnOne'
    | 'stickyBottom'
    | null
    | undefined;
};

/**
 * Ad component for ads that exist INSIDE the Article Builder
 */
export default component$<AdType>(
  ({ id, cssClasses, location }): JSX.Element => {
    return (
      <div
        id={id}
        data-target='ad'
        ad-type={location}
        class={adClasses({
          adType: location,
          class: cssClasses,
        })}
      />
    );
  }
);
